import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import './styles.scss';

type Prop = {
  budget: string;
  balance: string;
  gift: string;
  spent: string;
};

const BudgetChart = ({ budget, spent, balance, gift }: Prop) => {
  ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);
  const labels = [''];
  const data = {
    labels,
    datasets: [
      {
        label: 'Dataset 1',
        data: [budget],
        backgroundColor: '#E60A2B'
      },
      {
        label: 'Dataset 2',
        data: [spent],
        border: 'none',
        backgroundColor: '#2E3031'
      },
      {
        label: 'Dataset 1',
        data: [gift],
        border: 'none',
        backgroundColor: '#0080E5'
      },
      {
        label: 'Dataset 2',
        data: [balance],
        border: 'none',
        backgroundColor: '#EFF0F0'
      }
    ]
  };

  const options = {
    maintainAspectRatio: false,
    indexAxis: 'y' as const,
    scales: {
      x: {
        stacked: true,
        ticks: {
          display: false
        },
        border: { display: false },

        grid: {
          display: false,
          drawBorder: false
        }
      },
      y: {
        border: { display: false },

        ticks: {
          display: false
        },
        stacked: true,
        grid: {
          display: false,
          drawBorder: false
        }
      }
    },
    elements: {
      bar: {
        borderWidth: 2
      }
    },
    responsive: true,
    barThickness: 24,

    plugins: {
      legend: {
        display: false
      }
    }
  };

  return (
    <div className='h-[24px] min-w-full ml-[-8px] mt-5 mb-2 bar_box'>
      <Bar options={options} data={data} />
    </div>
  );
};

export default BudgetChart;
